import React from 'react';
import { Field, FormFile } from '@truvity/widget__forms';
import { FileField as OriginalFileField } from '@truvity/widget__forms-mui-theme/dist/components/specifics/FileField';

const acceptedFileMimeTypes = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/tiff': ['.tif', '.tiff'],
    'application/pdf': ['.pdf'],
};
const acceptedFileExtensions = Object.values(acceptedFileMimeTypes).flat().join(', ');

const MAX_FILE_SIZE_MB = 50;
const maxFileSizeInBytes = MAX_FILE_SIZE_MB * Math.pow(1024, 2);

export const FileField = (props: Field<FormFile | undefined>) => (
    <OriginalFileField
        {...props}
        fileUploadValidations={{
            accept: acceptedFileMimeTypes,
            maxSize: maxFileSizeInBytes,
        }}
        fileRestrictionsMessage={`Permitted file extensions are ${acceptedFileExtensions} and max file size is ${MAX_FILE_SIZE_MB} Mb.`}
    />
);
